<template>
  <div class="">
    <Card class="">
      <template #title> Tarifler </template>
      <template #content>
        <div class="mt-1 mb-2 mr-3">
          <Button icon="pi pi-plus " size="small" label="Yeni" @click="_YeniTarif()" />
        </div>
        <DataTable v-if="DataTable_render" :columns="columns" :data="TarifListesi" v-on:set-child-data="getDataChild"
          :editbutton="true" />
      </template>
    </Card>
  </div>
</template>

<script>
import DataTable from "../../DataTable/BasicDataTable.vue";
import GlobalServis from "../../../../../services/GlobalServis";
import { required, helpers } from "@vuelidate/validators";
import { useVuelidate } from "@vuelidate/core";

export default {
  setup: () => ({ v$: useVuelidate() }),
  data() {
    return {
      DataTable_render: true,
      TarifListesi: [],
      columns: [
        { field: "TarifAd", header: "Tarif" },
        { field: "BirimAd", header: "Birim" },
        { field: "Kalori", header: "Kalori" },
        { field: "TarifTarih", header: "Tarih" },
      ],

      TarifAd: null,
      TarifAciklama: null,
      Tarif_rowid: null,
    };
  },
  methods: {
    getDataChild(getdata_child) {
      this.Tarif_rowid = getdata_child.data.Tarif_rowid;
      this.$router.push({ path: "/Diyetisyen/DuzenleTarif", query: { TarifNo: this.Tarif_rowid } });
    },
    _YeniTarif() {
      this.$router.push({ path: "/Diyetisyen/YeniTarif" });
    },
    InitServis() {
      GlobalServis.GlobalServis("GET", "GetTarifTablosu", "").then((res) => {
        if (res.status == 200) {
          this.TarifListesi = res.data;
        } else if (res.status == 400) {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Önemli bir hata meydana geldi",
            life: 3000,
          });
        } else {
          this.$toast.add({
            severity: "error",
            summary: "Hata",
            detail: "Bilinmeyen bir hata meydana geldi",
            life: 3000,
          });
        }
      });
    },
  },
  mounted() {
    this.InitServis();
  },
  components: {
    DataTable,
  },
  validations() {
    return {
      TarifAd: {
        required: helpers.withMessage("Bu alan boş bırakılamaz", required),
      },
      TarifAciklama: {
        required: helpers.withMessage("Bu alan boş bırakılamaz", required),
      },
    };
  },
};
</script>